import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {MatchupStatus} from '@/app/core/models/bet/matchupStatus';
import {Matchup} from '@/app/core/models/bet/matchup';
import {Cacheable} from 'ts-cacheable';

@Injectable({
	providedIn: 'root'
})
export class MatchUpService {

	constructor(
		private readonly http: HttpClient
	) {}

	private readonly SERVICE_URI = `${environment.backendUrl}/matchup`;

	@Cacheable({
		maxAge: 5 * 60 * 1000,
		cacheKey: 'getMatchupsBySeason'
	})
	getMatchupsBySeason(): Observable<Record<MatchupStatus, Record<string, Matchup[]>>> {
		return this.http.get<Record<MatchupStatus, Record<string, Matchup[]>>>(
			`${this.SERVICE_URI}/current-season`
		);
	}


}
